module.exports = __webpack_public_path__ + "static/media/price-sept-21.dcf56772.pdf";